export default __webpack_public_path__ + "static/media/heatwave.db99bee6.svg";